import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { HeroSection } from "@/components/HeroSection";
import { StatsCounter } from "@/components/StatsCounter";
import { ServicesSection } from "@/components/ServicesSection";
import { PriceEstimator } from "@/components/PriceEstimator";
import { HowItWorks } from "@/components/HowItWorks";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { ComparisonTable } from "@/components/ComparisonTable";
import { ServiceAreasGrid } from "@/components/ServiceAreasGrid";
import { StoresSection } from "@/components/StoresSection";
import { PricingSection } from "@/components/PricingSection";
import { AppComingSoon } from "@/components/AppComingSoon";
import { TestimonialsSection } from "@/components/TestimonialsSection";
import { FoundersSection } from "@/components/FoundersSection";
import { PhotoGallery } from "@/components/PhotoGallery";
import { FAQSection } from "@/components/FAQSection";
import { CTASection } from "@/components/CTASection";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { FloatingReviews } from "@/components/FloatingReviews";
import { MobileStickyContact } from "@/components/MobileStickyContact";
import { PromoBar } from "@/components/PromoBar";
import AdminPage from "@/pages/AdminPage";
import AboutPage from "@/pages/AboutPage";
import PricingPage from "@/pages/PricingPage";
import CorporatePage from "@/pages/CorporatePage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import DeleteAccountPage from "@/pages/DeleteAccountPage";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <PromoBar />
      <Header />
      <HeroSection />
      <StatsCounter />
      <ServicesSection />
      <PriceEstimator />
      <HowItWorks />
      <WhyChooseUs />
      <ComparisonTable />
      <ServiceAreasGrid />
      <StoresSection />
      <PricingSection />
      <AppComingSoon />
      <TestimonialsSection />
      <FoundersSection />
      <PhotoGallery />
      <FAQSection />
      <CTASection />
      <Footer />
      <WhatsAppFloat />
      <FloatingReviews />
      <MobileStickyContact />
    </div>
  );
};

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/corporate" element={<CorporatePage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPostPage />} />
          <Route path="/services/:slug" element={<ServiceDetailPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/delete-account" element={<DeleteAccountPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
